// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;

import * as client_hooks from '../../../src/hooks.client.js';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84')
];

export const server_loads = [];

export const dictionary = {
		"/": [2],
		"/admin": [3],
		"/admin/billing/fbkr": [4],
		"/admin/billing/partneron": [5],
		"/admin/error-logs": [6],
		"/admin/management/printer": [7],
		"/admin/partner": [8],
		"/admin/partner/usage-status": [9],
		"/admin/printer": [10],
		"/as/intake/[token]": [11],
		"/external-auth": [12],
		"/fbkr-statement-print/[id]": [13],
		"/invoice-print/[invoiceID]": [14],
		"/ledger-print/[customerId]": [15],
		"/mobile/partner/as/completed": [16],
		"/mobile/partner/as/progress": [17],
		"/mobile/partner/as/register": [18],
		"/mobile/partner/as/today": [19],
		"/mobile/partner/customer": [20],
		"/mobile/partner/monitoring/customer": [21],
		"/mobile/partner/monitoring/data/supplies": [22],
		"/mobile/partner/monitoring/data/usage": [23],
		"/mobile/partner/myinfo": [24],
		"/mobile/partner/printer": [25],
		"/mobile/partner/resource/consumable-inventory": [26],
		"/mobile/partner/resource/equipment": [27],
		"/notimplement": [28],
		"/partner-usage-print/[id]": [77],
		"/partneron-statement-print/[id]": [78],
		"/partner/as/completed": [29],
		"/partner/as/consumable-usages": [30],
		"/partner/as/progress": [31],
		"/partner/as/register": [32],
		"/partner/as/sign/[id]": [33],
		"/partner/contract/invoice": [34],
		"/partner/contract/invoice/issued": [35],
		"/partner/contract/list": [36],
		"/partner/contract/sales": [37],
		"/partner/contract/sales/issued": [38],
		"/partner/contract/uncontracted-equipment": [39],
		"/partner/customer": [40],
		"/partner/dashboard": [41],
		"/partner/ledger/advance-payment": [42],
		"/partner/ledger/transaction": [43],
		"/partner/members": [44],
		"/partner/monitoring/customer": [45],
		"/partner/monitoring/data/supplies": [46],
		"/partner/monitoring/data/usage": [47],
		"/partner/myinfo": [48],
		"/partner/operation/company": [49],
		"/partner/operation/consumables": [50],
		"/partner/operation/custom-equipment-model": [51],
		"/partner/operation/warehouse": [52],
		"/partner/payment/account-lookup": [53],
		"/partner/payment/cash-receipt": [54],
		"/partner/payment/cms-member": [55],
		"/partner/payment/cms-withdrawal": [56],
		"/partner/penalty/billing": [57],
		"/partner/printer": [58],
		"/partner/printer/agents": [59],
		"/partner/printer/unregistered": [60],
		"/partner/report/as-consumable-cost": [61],
		"/partner/report/as-type": [62],
		"/partner/report/customer-count": [63],
		"/partner/report/customer-monthly-sales": [64],
		"/partner/report/engineer": [65],
		"/partner/report/equipment-count": [66],
		"/partner/report/sales-vs-consumable-cost": [68],
		"/partner/report/sales": [67],
		"/partner/report/usage": [69],
		"/partner/resource/consumable-inventory": [70],
		"/partner/resource/consumables": [71],
		"/partner/resource/equipment": [72],
		"/partner/sales-evidence/completed": [73],
		"/partner/sales-evidence/tax-invoice": [74],
		"/partner/supplies/history": [75],
		"/partner/supplies/management": [76],
		"/penalty-print/[id]": [79],
		"/pricing": [80],
		"/register": [81],
		"/reset-password": [82],
		"/sales-print/[id]": [83],
		"/usage-print/[id]": [84]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);